const styles = (theme) => ({
  title: {
    margin: '0',
  },
  header: {
    marginBottom: '20px',
  },
  emptyMessage: {
    [theme.breakpoints.down('sm')]: {
      marginTop: '20px',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '10%',
      marginBottom: '40px',
    },
  },
  cta: {
    padding: '0 16px',
    borderBottom: 'unset',
    maxWidth: '1200px',
    margin: '24px auto',

    '&.mobile': {
      marginTop: '16px',
    },

    '& .loyalty_cta': {
      bottom: '150px',
    },

    '& .collapsed .collapsed_wrapper': {
      alignItems: 'flex-start',
      rowGap: '10px',
    },
  },
  buttonHubspotContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '25px 13px 0',
  },
  buttonHubspot: {
    width: '100%',
    height: '35px',
  },
  buttonHubspotContainerDesktop: {
    display: 'flex',
    padding: '25px 13px 0',
  },
  buttonHubspotDesktop: {
    width: '50%',
    height: '35px',
  },
  chaptersToggleButtonMobile: {
    maxWidth: '1rem',
    maxHeight: '1rem',

    [theme.breakpoints.down('sm')]: {
      maxWidth: '1.3rem',
      maxHeight: '1.3rem',
    },
  },
  dividerContent: {
    fontSize: '13px',
  },
  breadCrumbButton: {
    border: 'unset',
    backgroundColor: 'unset',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  mobileDocListContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  mobileCreateFolderContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '320px',
    margin: '0 auto',
    height: '100%',
    '&>div': {
      width: '100%',
    },
  },
  errorMessage: {
    fontSize: '12px',
    margin: '5px 0 0',
    color: '#FD6765',
  },
  tabContent: {
    '& .MuiTabPanel-root': {
      padding: '0px',
    },
    width: '100%',
  },
  tabs: {
    width: 'fit-content',
    border: '1px solid #e6e6e6',
    borderRadius: 25,
    minHeight: '20px !important',
    height: '31px',
    '& .MuiTab-root.Mui-selected': {
      backgroundColor: '#e6e6e6',
      borderRadius: '30px',
    },
    '& .MuiTab-root': {
      opacity: '100%',
    },
    '& .MuiTabPanel-root': {
      padding: '0px',
    },
  },
  tabHeaderBox: {
    display: 'flex',
    alignItems: 'center',
  },
  tabHeaderText: {
    fontSize: '14px',
    fontWeight: '500',
    letterSpacing: 0,
    textTransform: 'none',
  },
  tabHeaderNewText: {
    fontSize: '10px',
    fontWeight: '800',
    textTransform: 'none',
    marginLeft: '10px',
    backgroundColor: '#5dc9a2',
    height: '20px',
    width: '31px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tabItem: {
    minHeight: '20px !important',
    height: '30px',
    '&.rootClassname': {
      padding: '4px 12px',
    },
  },
  headerTitle: {
    fontSize: '24px',
    fontWeight: '600',
    marginRight: '10px',
  },
  headerTitleMobile: {
    fontSize: '18px',
    fontWeight: '600',
    marginRight: '10px',
  },
  personalErrorHeader: {
    fontWeight: '600',
    color: '#000',
  },
  personalErrorText: {
    marginTop: '15px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#000',
  },
  personalEmptyContetnt: {
    maxWidth: '50%',
    margin: 'auto',
    marginTop: '40px !important',
  },
});

export default styles;
